import { animated, useTrail } from 'react-spring';
import { Swiper, SwiperSlide } from 'swiper/react';
import Achievement from '@components/achievement';
import { achievements } from '@components/user-profile/constants';
import useBreakpoint from '@hooks/useBreakpoint';
import styles from './achievements.module.scss';

const GAMES_ACHIEVEMENTS = [
  { game: 'General', achievements },
  { game: 'Coinflip', achievements },
  { game: 'Jackpot', achievements },
];

const GameAchievements = ({ game, achievements }: typeof GAMES_ACHIEVEMENTS[0]) => {
  /* Animations */

  const achievementsListAnimation = useTrail(achievements.length, {
    from: { opacity: 0, scale: 0 },
    to: { opacity: 1, scale: 1 },
  });

  /* Components */

  const Achievements: JSX.Element[] = achievementsListAnimation.map((style, idx) => (
    <animated.article key={idx} style={style}>
      <Achievement {...achievements[idx]} simplify={false} />
    </animated.article>
  ));

  return (
    <div className={styles['achievement-item']}>
      <h3>{game}</h3>

      <div className={styles['achievement-item__list']}>{Achievements}</div>
    </div>
  );
};

const Achievements = (): JSX.Element => {
  /* Hooks and State */

  const { windowWidth, breakpoints } = useBreakpoint();
  const isDesktop: boolean = windowWidth >= breakpoints.XL;

  /* Components */

  const GamesAchivements: JSX.Element[] = GAMES_ACHIEVEMENTS.map(({ game, achievements }) => (
    <SwiperSlide key={game}>
      <GameAchievements {...{ game, achievements }} />
    </SwiperSlide>
  ));

  const DesktopList: JSX.Element = (
    <Swiper spaceBetween={35} slidesPerView={2} className={styles.achievements__list}>
      {GamesAchivements}
    </Swiper>
  );

  const MobileList: JSX.Element = <div className={styles.achievements__list}>{GamesAchivements}</div>;

  return (
    <section className={styles.achievements}>
      <h1 className='user-profile-title'>Achievements</h1>

      {isDesktop ? DesktopList : MobileList}
    </section>
  );
};

export default Achievements;
